<template>
  <div>
    <el-drawer title="查找评审机构" size="45%" :visible.sync="visible">
      <el-row>
        <el-col :span="19" :offset="1">
          <el-input
            v-model="keyword"
            maxlength="30"
            show-word-limit
            clearable
            placeholder="请输入名称"
          ></el-input>
        </el-col>
        <el-col :span="3" :offset="1">
          <el-button
            size="medium"
            icon="el-icon-search"
            @click="search"
          ></el-button>
        </el-col>
      </el-row>
      <el-table
        :data="tableData"
        v-loading="loading"
        border
        fit
        stripe
        class="mt10"
      >
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column
          property="boardId"
          label="单位编号"
          width="80"
        ></el-table-column>
        <el-table-column
          property="boardName"
          label="单位名称"
        ></el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="100"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleSelectd(scope.row)"
              >确认选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>

<script>
import { listAll } from "@/api/tdcs/board.js";

export default {
  data() {
    return {
      keyword: "",
      visible: false,
      loading: false,
      loaded: false,
      tableData: [],
      cacheData: [],
    };
  },
  methods: {
    handleSelectd(row) {
      this.visible = false;
      this.$emit("selectd", row.boardId, row.boardName);
    },
    loadBoard() {
      this.loading = true;
      listAll(this.keyword).then((res) => {
        this.tableData = res;
        this.loading = false;
      });
    },
    search() {
      if (this.cacheData.length == 0) {
        this.cacheData = this.tableData;
      }

      if (!this.keyword) {
        this.tableData = this.cacheData;
        return;
      }

      this.tableData = this.cacheData.filter((value) =>
        value.boardName.includes(this.keyword)
      );
    },
    show() {
      this.visible = true;
      if (this.tableData.length == 0) {
        this.loadBoard();
      }
    },
  },
};
</script>